import React, { useEffect, useMemo, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { ModalType, confirmModalState } from "../../recoil/confirm";
import { OrderType } from "../../controller/UserController";
import moment from "moment";
import "moment/locale/ko";
import { useNavigate } from "react-router-dom";
import { orderDetailRealmType } from "../../recoil/cart";
import OrderHistoryController from "../../controller/OrderHistoryController";
import { ReceiptModalType, receiptModalState } from "../../recoil/receiptModal";
import RecoilReceiptModal from "../../components/modal/RecoilReceiptModal";
import StoreController from "../../controller/StoreController";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";

const OrderHistory = () => {
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] =
    useRecoilState<ModalType>(confirmModalState);
  const [receiptOpen, setReceiptOpen] =
    useRecoilState<ReceiptModalType>(receiptModalState);

  const scrollRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState<number>(0);
  const [orderList, setOrderList] = useState<OrderType[]>([]);
  const [isBottom, setIsBottom] = useState<boolean>(false);

  // API 호출
  const getOrderHistory = async () => {
    try {
      const oParams = {
        page: page,
      };
      const oRes = await OrderHistoryController.getCompletedOrders(oParams);

      if (oRes && oRes.data && oRes.data.success) {
        console.log("getCompletedOrders", oRes.data);
        setOrderList([...orderList, ...oRes.data.completed_orders]);
        setPage(page + 1);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getOrderReceipt = async (item: OrderType) => {
    try {
      const oParams = {
        order_id: item.order_id,
        payment_method: "[pg-thrupay]:free",
        is_cancel: false,
      };
      const oRes = await OrderHistoryController.historyDetail(oParams);

      if (oRes && oRes.data) {
        console.log("historyDetail", oRes.data);
        setReceiptOpen({
          visibleConfirm: true,
          handleConfirm: {},
          modalData: oRes.data,
        });
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const setFavorite = async (item: OrderType) => {
    try {
      const oParams = {
        store_id: item.store_id,
        favorites_flag: item.favorites_flag === 1 ? 0 : 1,
      };
      const oRes = await StoreController.setFavoritesStore(oParams);

      if (oRes && oRes.data && oRes.data.success) {
        console.log("setFavoritesStore", oRes.data);
        orderList.map((order) => {
          if (order.store_id === item.store_id)
            order.favorites_flag = order.favorites_flag === 1 ? 0 : 1;
        });
        setOrderList([...orderList]);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const deleteHistory = async (item: OrderType) => {
    try {
      const oParams = {
        order_id: item.order_id,
      };
      const oRes = await OrderHistoryController.deleteOrderFromView(oParams);

      if (oRes && oRes.data && oRes.data.success) {
        console.log("deleteOrderFromView", oRes.data);
        setOrderList([
          ...orderList.filter((order) => order.order_id !== item.order_id),
        ]);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const reorderHistory = (item: OrderType) => {
    const reorder_data: orderDetailRealmType[] = [];
    item.prd_list.map((product) => {
      const reorderItem: orderDetailRealmType = {
        store_id: item.store_id,
        product_id: product.product_id,
        product_name: product.prd_name,
        product_org_price: Number(product.prd_base_price),
        product_quantity: product.quantity,
        product_total_amount: Number(product.total_amount_incl),
        options: product.option_list.map((obj) => {
          return {
            option_id: obj.product_option_id,
            option_type_id: obj.option_type_id,
            option_type_name: obj.option_type_name,
            option_name: obj.name,
            option_price: obj.price,
            option_input_max: obj.input_max,
            option_input_min: obj.input_min,
          };
        }),
      };
      console.log("reorderItem", reorderItem);
      reorder_data.push(reorderItem);
    });
    AsyncLocalStorage.setItem(
      "reorder",
      JSON.stringify({
        store_id: item.store_id,
        data: reorder_data,
      })
    );
    navigate("/order/payment");
  };

  const removeHistory = (item: OrderType) => {
    setModalOpen({
      visibleConfirm: true,
      title: "삭제한 후에는 되돌릴 수 없습니다.\n정말로 삭제하시겠습니까?",
      handleConfirm: () => deleteHistory(item),
      successText: "삭제",
      cancelText: "취소",
    });
  };

  const handleScroll = () => {
    const scrollElement = scrollRef.current;
    if (scrollElement) {
      setIsBottom(
        scrollElement.scrollHeight - scrollElement.scrollTop <=
          scrollElement.clientHeight
      );
    }
  };

  useEffect(() => {
    AsyncLocalStorage.removeItem("reorder");
    getOrderHistory();
    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => {
        scrollElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  useEffect(() => {
    if (isBottom) {
      getOrderHistory();
    }
  }, [isBottom]);

  const RenderHistoryItem = useMemo(() => {
    return (
      <div ref={scrollRef} className="orderHistoryWrap">
        {orderList.map((item, index) => (
          <div key={index} className="historyCard flexSpaceBetween">
            <div className="left">
              <div className="title">
                <h2>{item.store_name}</h2>
                <button onClick={() => setFavorite(item)}>
                  {item.favorites_flag === 1 ? (
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_heartColor.svg`}
                      alt="heart"
                      style={{
                        width: "33px",
                      }}
                    />
                  ) : (
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_heart.svg`}
                      alt="heart"
                      style={{
                        width: "33px",
                      }}
                    />
                  )}
                </button>
                <img
                  onClick={() =>
                    navigate("/order/main", {
                      state: { store_id: item.store_id },
                    })
                  }
                  src={`${process.env.PUBLIC_URL}/svg/ic_more_button.svg`}
                  alt="안내사항 아이콘"
                  style={{
                    width: "38px",
                    marginLeft: "auto",
                  }}
                />
              </div>
              <p>{moment(item.created_at).format("MM/DD HH:mm")}</p>
              <h3>
                {item.prd_list[0].prd_name}
                {item.prd_list.length - 1 > 0
                  ? ` 외 ${item.prd_list.length - 1}건`
                  : ""}
              </h3>
            </div>
            <div className="right">
              <button
                onClick={() => removeHistory(item)}
                className="removeIcon"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                  alt="삭제 아이콘"
                  style={{
                    width: "44px",
                  }}
                />
              </button>
              <button
                className="receiptButton"
                onClick={() => getOrderReceipt(item)}
              >
                영수증보기
              </button>
              <button
                className="reorderButton"
                onClick={() => reorderHistory(item)}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`}
                  alt="플러스 아이콘"
                  style={{
                    width: "32px",
                  }}
                />
                재주문하기
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  }, [orderList, page]);

  return (
    <>
      <Style>
        <div className="wrapper">
          <h1>주문내역</h1>
          {RenderHistoryItem}
        </div>
      </Style>
      <RecoilReceiptModal />
    </>
  );
};

export default OrderHistory;

const Style = styled.div`
  .wrapper {
    width: 100%;
    height: 100vh;
    padding: 5vh 0;
    overflow: hidden;
  }
  h1 {
    margin-bottom: 26px;
    font-size: 40px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }

  /* orderHistoryWrap */
  .orderHistoryWrap {
    height: calc(100% - 86px);
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    overflow-y: auto;
  }
  .historyCard {
    width: calc(50% - 8px);
    padding: 20px 36px;
    border-radius: 10px;
    align-items: flex-start;
    border: 1px solid #737373;
    gap: 8px;

    .title {
      display: flex;
      align-items: center;
    }
  }

  button {
    padding: 18px 45px;
    border-radius: 10px;
    background: #333;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    white-space: nowrap;
  }

  /* left */
  .left {
    max-width: 60%;
    h2 {
      font-size: 32px;
      font-weight: 600;
      width: auto;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    h3 {
      font-size: 28px;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p {
      margin: 9px 0 40px 0;
      font-size: 20px;
      font-weight: 400;
      color: #a7a7a7;
    }
    .title {
      align-items: center;
    }
    button {
      padding: 0;
      text-align: right;
      display: inline;
      width: auto;
      margin: 0 30px 0 15px;
      background: none;
    }
  }
  /* right */
  .right {
    display: flex;
    flex-direction: column;
    gap: 15px;

    button {
      background: none;
      display: inline-flex;
      justify-content: center;
      padding: 15px 50px;
    }
    .removeIcon {
      display: flex;
      justify-content: flex-end;
      margin-left: auto;

      padding: 0;
    }
    .receiptButton {
      border: 1px solid #a7a7a7;
    }
    .reorderButton {
      align-items: center;
      background: linear-gradient(180deg, #6490e8 0%, #001e62 100%);

      img {
        margin-right: 12px;
      }
    }
  }
`;
